import React, { useState } from "react";
import "./Header.scss";
import Noti from "../../assets/images/noti.svg";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getNotifications, markRead } from "../../store/reducers/notifications";
import { AccordionDetails, Typography, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import MuiAccordion from "@mui/material/Accordion";
import { styled } from "@mui/material/styles";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid white`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const NotificationItem = ({ data }) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  return (
    <li style={{ opacity: data.is_seen ? 0.5 : 1 }}>
      <Accordion
        onChange={() => {
          if (data.is_seen) return;
          setShow((prevState) => !prevState);
          dispatch(markRead([data.id]));
        }}
        sx={{
          background: "transparent",
          boxShadow: "none",
          border: "1px solid #43484e",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ justifyContent: "start", alignItems: "center" }}
        >
          <img src={Noti} style={{ paddingRight: "1rem" }} alt="" />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography>{data.title}</Typography>
            <div style={{ fontSize: "small" }}>{data.time_since}</div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Typography
            sx={{
              borderLeft: "1px solid gray",
              paddingLeft: "1rem",
            }}
          >
            {data.description}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </li>
  );
};

const Notification = ({ setOpen, setAnchor }) => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);

  const handleMarkAsRead = (ids) => {
    dispatch(markRead(ids));
    setOpen(false);
    setAnchor(false);
  };

  return (
    <div className="Notification">
      <div className="First">
        <div className="FirstH">
          <div className="head">Notifications</div>
        </div>
        {notifications &&
        notifications.count &&
        notifications.unseen_notification_count ? (
          <div
            className="Read"
            onClick={() => handleMarkAsRead(notifications.unread_ids)}
          >
            Mark all as read
          </div>
        ) : (
          false
        )}
      </div>
      <ul
        className="Second"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {notifications.count ? (
          notifications.results.map((notification, idx) => (
            <NotificationItem key={idx} data={notification} />
          ))
        ) : (
          <span style={{ color: "gray" }}>No notifications</span>
        )}
      </ul>
      {notifications.count && notifications.next ? (
        <span
          className="show-more-btn"
          onClick={() => dispatch(getNotifications(notifications.next))}
        >
          Show more
        </span>
      ) : (
        false
      )}
    </div>
  );
};

export default Notification;
